import { dateHeader, formatCellDateWithSeconds } from './timeModeCell';

export const makeMobileUserLogColumn = () => {
  const renderSeverity = (severity: number) => {
    return (
      <span
        style={{
          color: severity === 0 ? 'blue' : severity === 1 ? 'orange' : 'red',
        }}
      >
        {severity === 0 ? 'Information' : severity === 1 ? 'Warning' : 'Alert'}
      </span>
    );
  };

  return [
    {
      header: dateHeader('Timestamp'),
      accessorKey: 'timestamp',
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDateWithSeconds(table, row.original.timestamp),
    },
    {
      header: 'Severity',
      accessorKey: 'severity',
      size: 90,
      cell: ({ row }) => renderSeverity(row.original.severity),
      style: {
        textAlign: 'center',
      },
    },
    {
      header: 'Message',
      accessorKey: 'message',
      size: 'auto',
      style: { textAlign: 'left' },
    },
  ] as Array<any>;
};
